<div class='body'>

  @if (userRolCheck('permiso_pesar')) {
    <mat-card class='mat-card pointer' routerLink="/carga">
      <mat-card-header>
        <div mat-card-avatar>
          <mat-icon color="primary" class='cardIcon'>speed</mat-icon> <!-- receipt_long -->
        </div>
        <mat-card-title class='cardTitle'>Pesaje</mat-card-title>
      </mat-card-header>
      <p class='cardText'>Realiza un nuevo pesaje en la báscula.</p>
    </mat-card>
  }

  @if (userRolCheck('permiso_total')) {
    <mat-card class='mat-card pointer' routerLink="/camiones">
      <mat-card-header>
        <div mat-card-avatar>
          <mat-icon color="primary" class='cardIcon'>local_shipping</mat-icon>
        </div>
        <mat-card-title class='cardTitle'>Camiones</mat-card-title>
      </mat-card-header>
      <p class='cardText'>Administra los camiones del sistema.</p>
    </mat-card>
  }

  @if (authService.canAccessContenedores()) {
    <mat-card class='mat-card pointer' routerLink="/contenedores">
      <mat-card-header>
        <div mat-card-avatar>
          <mat-icon color="primary" class='cardIcon'>inventory_2</mat-icon>
        </div>
        <mat-card-title class='cardTitle'>Contenedores</mat-card-title>
      </mat-card-header>
      <p class='cardText'>Administra los contenedores del sistema.</p>
    </mat-card>
  }


  @if (userRolCheck('permiso_registros')) {
    <mat-card class='mat-card pointer' routerLink="/ver-registros">
      <mat-card-header>
        <div mat-card-avatar>
          <mat-icon color="primary" class='cardIcon'>source</mat-icon>
        </div>
        <mat-card-title class='cardTitle'>Registros</mat-card-title>
      </mat-card-header>
      <p class='cardText'>Gestiona pesajes y movimientos de contenedor.</p>
    </mat-card>
  }

  @if (userRolCheck('permiso_total')) {
    <mat-card class='mat-card pointer' routerLink="/residuos">
      <mat-card-header>
        <div mat-card-avatar>
          <mat-icon color="primary" class='cardIcon'>category</mat-icon>
        </div>
        <mat-card-title class='cardTitle'>Residuos</mat-card-title>
      </mat-card-header>
      <p class='cardText'>Administra los materiales del programa.</p>
    </mat-card>
  }

  @if (userRolCheck('permiso_clasificar')) {
    <mat-card class='mat-card pointer' routerLink="/clasificar-registros">
      <mat-card-header>
        <div mat-card-avatar>
          <mat-icon color="primary" class='cardIcon'>fact_check</mat-icon>
        </div>
        <mat-card-title class='cardTitle'>Clasificar</mat-card-title>
      </mat-card-header>
      <p class='cardText'>Clasificar los registros.</p>
    </mat-card>
  }

</div>
